import BaseReducer from '../../utilities/BaseReducer';
import ILoginState from './models/ILoginState';
import LoginAction from './LoginAction';
import IAction from '../../models/IAction';
import ValidateAccountModel from './models/login/ValidateAccountModel';
import UserAuthenticatedModel from './models/login/UserAuthenticatedModel';
import TokenModel from './models/login/TokenModel';
import moment from 'moment';

export default class LoginReducer extends BaseReducer<ILoginState> {
    public readonly initialState: ILoginState = {
        currentComponent: 'validateAccount',
        username: '',
        account: null,
        user: null,
        token: null,
        banner: [
            {
                id: 'FXd__footer',
                message: `Banco BASE S.A. Institución de Banca Múltiple © ${moment().year()} Todos los derechos reservados. \
                 Tel. 01 800 22 626 22 | 01 800 Banco Base | Mty: 81 51 23 83 Versión: 1.6.1.696 | V2.3_SP2_09122019_1800|UNE`,
                style: {
                    borderRadius: '0px',
                    textAlign: 'center',
                },
                className: 'item__banner',
            },
        ],
        geolocation: {
            userConsent: true,
            isBlocked: false,
            altitude: null,
            latitude: null,
            longitude: null,
        },
    };

    public [LoginAction.REQUEST_VALIDATE_ACCOUNT_FINISHED](state: ILoginState, action: IAction<ValidateAccountModel>): ILoginState {
        return {
            ...state,
            account: action.payload!,
        };
    }

    public [LoginAction.REQUEST_AUTHENTICATE_FINISHED](state: ILoginState, action: IAction<UserAuthenticatedModel>): ILoginState {
        return {
            ...state,
            user: action.payload!,
        };
    }

    public [LoginAction.RESET_ACCOUNT](state: ILoginState, action: IAction<UserAuthenticatedModel>): ILoginState {
        return {
            ...state,
            account: null,
        };
    }

    public [LoginAction.RESET_USERNAME](state: ILoginState, action: IAction<UserAuthenticatedModel>): ILoginState {
        return {
            ...state,
            username: '',
        };
    }

    public [LoginAction.CURRENT_COMPONENT](state: ILoginState, action: IAction<string>): ILoginState {
        return {
            ...state,
            currentComponent: action.payload,
        };
    }

    public [LoginAction.ACTUALIZE_USERNAME](state: ILoginState, action: IAction<string>): ILoginState {
        return {
            ...state,
            username: action.payload,
        };
    }

    public [LoginAction.REQUEST_TOKEN_FINISHED](state: ILoginState, action: IAction<TokenModel>): ILoginState {
        return {
            ...state,
            token: action.payload!,
        };
    }

    public [LoginAction.INSERT_BANNER](state: ILoginState, action: IAction<any>): ILoginState {
        return {
            ...state,
            banner: action.payload!,
        };
    }

    public [LoginAction.REMOVE_BANNER](state: ILoginState, action: IAction<any>): ILoginState {
        return {
            ...state,
            banner: action.payload!,
        };
    }

    public [LoginAction.SET_GEO_USER_CONSENT](state: ILoginState, action: IAction<any>): ILoginState {
        return {
            ...state,
            geolocation: {
                ...state.geolocation,
                userConsent: action.payload,
            },
        };
    }

    public [LoginAction.SET_GEO_IS_BLOCKED](state: ILoginState, action: IAction<any>): ILoginState {
        return {
            ...state,
            geolocation: {
                ...state.geolocation,
                isBlocked: true,
            },
        };
    }

    public [LoginAction.SET_GEOLOCATION](state: ILoginState, action: IAction<any>): ILoginState {
        return {
            ...state,
            geolocation: {
                ...action.payload,
                isBlocked: false,
                userConsent: state.geolocation.userConsent,
            },
        };
    }
}
